import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { personHealthProfileApi } from '../../services/personHealthProfileApi';
import { CreatePersonHealthProfile } from '../../dtos/PersonHealthProfiles/index';
import { personHealthProfileKeys } from './useGetPersonHealthProfile';
import { personKeys } from '../Person/useGetPerson';

export function useCreatePersonHealthProfile() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: CreatePersonHealthProfile) => personHealthProfileApi.create(data),
    onSuccess: (response) => {
      if (response.isSuccess) {
        toast.success('Successfully created health profile');
        // Invalidate both personHealthProfile and person queries
        queryClient.invalidateQueries({ queryKey: personHealthProfileKeys.all });
        queryClient.invalidateQueries({ queryKey: personKeys.all });
      } else {
        toast.error(`Error: ${response.errorMessage || 'Failed to create health profile'}`);
      }
    },
    onError: (error: Error) => {
      toast.error(`Error: ${error.message || 'Failed to create health profile'}`);
    },
  });
}
